(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["etg-attribution"] && !Shopify.designMode) return;
  try {
    (() => {
  const storageKey = 'etg_first_touch_v1';
  const postedKey = 'etg_first_touch_posted_v1';
  const params = new URLSearchParams(window.location.search);
  let referrerHost = '';

  try {
    referrerHost = document.referrer ? new URL(document.referrer).hostname : '';
  } catch (error) {
    referrerHost = '';
  }

  const signal = [
    params.get('utm_source'),
    params.get('utm_medium'),
    referrerHost,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  let firstTouch = null;

  try {
    firstTouch = JSON.parse(window.localStorage.getItem(storageKey) || 'null');
  } catch (error) {
    firstTouch = null;
  }

  if (!firstTouch && (signal.includes('chatgpt') || signal.includes('openai'))) {
    firstTouch = {
      source: 'ChatGPT/OpenAI',
      utmSource: (params.get('utm_source') || '').slice(0, 100),
      utmMedium: (params.get('utm_medium') || '').slice(0, 100),
      landing: window.location.pathname.slice(0, 255),
      referrer: referrerHost.slice(0, 255),
    };

    try {
      window.localStorage.setItem(storageKey, JSON.stringify(firstTouch));
    } catch (error) {
      return;
    }
  }

  if (!firstTouch || firstTouch.source !== 'ChatGPT/OpenAI') return;

  const marker = JSON.stringify(firstTouch);

  try {
    if (window.sessionStorage.getItem(postedKey) === marker) return;
  } catch (error) {
    return;
  }

  const root = window.Shopify?.routes?.root || '/';

  fetch(`${root}cart/update.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      attributes: {
        _etg_first_source: firstTouch.source,
        _etg_first_utm_source: firstTouch.utmSource,
        _etg_first_utm_medium: firstTouch.utmMedium,
        _etg_first_landing: firstTouch.landing,
        _etg_first_referrer: firstTouch.referrer,
      },
    }),
  })
    .then((response) => {
      if (!response.ok) throw new Error('Cart attribution update failed');
      window.sessionStorage.setItem(postedKey, marker);
    })
    .catch(() => {});
})();
  } catch(e) { console.error(e); }
})();

})();
